export default __webpack_public_path__ + "static/media/image.kk-technologies.a053fbe9.png";